var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "collapse-body pb-0" },
    [
      _c("csp-form-group-checkbox", {
        attrs: {
          "as-switch": "",
          form: _vm.customerForm,
          "hide-label": "",
          "label-property": "isCompanyCarForCustomer",
          property: "gender",
          "unchecked-value": "",
          value: "company",
        },
      }),
      _vm._v(" "),
      _c("csp-create-customer-form", {
        attrs: {
          "customer-form": _vm.customerForm,
          "is-fleet-or-major-customer": _vm.isFleetOrMajorCustomer,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }